import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';
import { TimeSlotWithValidation } from '../../GuestDetailsEdit';
import HourPicker from '@/views/components/HourPicker/HourPicker.vue';

@Options({
  name: 'TimesSlot',
  props: {
    tSlot: {
      type: Object as PropType<TimeSlotWithValidation>,
      required: true,
    },
    timesSlotslength: {
      type: Number,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled:{
      type: Boolean,
      required:false,
      default:false
    }
  },
components: {
  HourPicker,
},
  watch: {

  },
  emits: ['delete-slot', 'time-slot-edited'],
})
export default class TimesSlot extends Vue {
  tSlot!: TimeSlotWithValidation;
  timesSlotslength!: number;
  isEdit!: boolean;
  disabled!: boolean;

  since = 0;
  until = 0;

  mounted(): void {
    this.since = this.tSlot.slot.timeSince?.getUTCHours() ?? 0;
    this.until = this.tSlot.slot.timeUntil?.getUTCHours() ?? 0;
  }

  timeValid() {
    if (this.tSlot.slot.timeSince && this.tSlot.slot.timeUntil) {
      this.tSlot.isValid =
        this.tSlot.slot.timeUntil.getTime() > this.tSlot.slot.timeSince.getTime();
    }
    return this.tSlot.isValid;
  }

  handleTimeSlotRemove() {
    this.$emit('delete-slot', this.tSlot);
  }

  updateSince(value: number) {
    this.tSlot.slot.timeSince?.setUTCHours(value);

    this.resetMinutes(this.tSlot.slot.timeSince);
    this.timeValid();
    this.$emit('time-slot-edited');
  }

  updateUntil(value: number) {
    this.tSlot.slot.timeUntil?.setUTCHours(value);

    this.resetMinutes(this.tSlot.slot.timeUntil);
    this.timeValid();
    this.$emit('time-slot-edited');
  }

  resetMinutes(date?: Date) {
    if (date) {
      date.setMinutes(0, 0, 0);
      return date;
    }
  }
}
